// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__NdgbM","select":"Header_select__iGw8o","clinic":"Header_clinic__111Em"};